/**
 * Signup geography + billing currency allowlists (mirrors API geo-billing.constants).
 * Defaults: India / INR.
 */

export const DEFAULT_COUNTRY = "IN";
export const DEFAULT_CURRENCY = "INR";

export const SUPPORTED_BILLING_CURRENCIES = Object.freeze(["INR", "USD"]);

export const COUNTRIES = Object.freeze([
  { code: "IN", label: "India" },
  { code: "US", label: "United States" },
  { code: "GB", label: "United Kingdom" },
  { code: "AE", label: "United Arab Emirates" },
  { code: "SG", label: "Singapore" },
  { code: "AU", label: "Australia" },
  { code: "CA", label: "Canada" },
  { code: "DE", label: "Germany" },
  { code: "FR", label: "France" },
  { code: "NL", label: "Netherlands" },
  { code: "IE", label: "Ireland" },
  { code: "NZ", label: "New Zealand" },
  { code: "ZA", label: "South Africa" },
  { code: "OTHER", label: "Other" },
]);

export const COUNTRY_DEFAULT_CURRENCY = Object.freeze({
  IN: "INR",
  US: "USD",
  GB: "USD",
  AE: "USD",
  SG: "USD",
  AU: "USD",
  CA: "USD",
  DE: "USD",
  FR: "USD",
  NL: "USD",
  IE: "USD",
  NZ: "USD",
  ZA: "USD",
  OTHER: "USD",
});

export const CURRENCY_OPTIONS = Object.freeze([
  { code: "INR", label: "INR — Indian Rupee" },
  { code: "USD", label: "USD — US Dollar" },
]);

export function defaultCurrencyForCountry(countryCode) {
  const code = String(countryCode || DEFAULT_COUNTRY).toUpperCase();
  return COUNTRY_DEFAULT_CURRENCY[code] || DEFAULT_CURRENCY;
}
